import { Box,Text } from "@chakra-ui/react";
import { ReactComponent as Approved } from '../../svg/enabledTopic.svg'
import { ReactComponent as Declined } from '../../svg/disabledTopic.svg'
import { ReactComponent as Pending } from '../../svg/warning.svg'

export default function StudentProfileStatistics({ participants }) {
    return (
       <Box
                w='100%'
                border='1px solid rgba(0, 0, 0, 0.1)'
                boxShadow='0px 4px 10px rgba(0, 0, 0, 0.1)'
                borderRadius='10px'
                px='1rem'
                mb='1rem'
                bgColor='white'
            >
            {participants.user=== undefined ?
                <Box
                        w='100%'
                        d='flex'
                        justifyContent='space-between'
                        alignItems='center'
                        py='1rem'
                        fontSize='15px'
                        color='#000000'
                        fontWeight='600'
                        style={{ fontFamily: 'Mulish, sans-serif' }}
                        borderBottom='1px solid rgba(0, 0, 0, 0.05)'
                    >
                    </Box>:
            <Box
                        w='100%'
                        d='flex'
                        justifyContent='space-between'
                        alignItems='center'
                        py='1rem'
                        fontSize='15px'
                        color='#000000'
                        fontWeight='600'
                        style={{ fontFamily: 'Mulish, sans-serif' }}
                        borderBottom='1px solid rgba(0, 0, 0, 0.05)'

                    >
                        <Text width='14%' cursor="pointer">{participants.user.first_name} {participants.user.last_name}</Text>
                        <Text width='12%' textAlign='center'>{participants.user.student_id}</Text>
                        <Text width='12%' textAlign='center'>{participants.user.email}</Text>
                        <Text width='12%' textAlign='center'>{participants.user.years === null ? '' : participants.user.years.name}</Text>
                        <Text width='14%' textAlign='center'>{participants.user.degrees === null ? '' : participants.user.degrees.name}</Text>
                        <Text width='12%' textAlign='center'>{participants.user.specifications === null ? '' : participants.user.specifications.name}</Text>
                        <Text width='12%' textAlign='center'>
                            <Box
                                bg={participants.user.status === 'A' ? '#4ea348' : participants.user.status === 'D' ? '#c91d12' : "#ff8c00"}
                                border='2px solid #FFFFFF'
                                boxShadow='0px 2px 6px rgba(0, 0, 0, 0.1)'
                                p='10px 20px'
                                borderRadius='20px'
                                style={{ fontFamily: 'Mulish, sans-serif', gap: '0.5rem' }}
                                fontWeight='700'
                                color='#ffffff'
                                fontSize={['7px', '10px', '11px', '15px']}
                                d='flex'
                                justifyContent='center'
                                alignItems='center'
                            >
                                {participants.user.status === 'A' ? <Approved width='15px' height='15px' /> : participants.user.status === 'D' ? <Declined width='15px' height='15px' /> : <Pending width='15px' height='15px' fill="#ffffff" />}
                                {participants.user.status === 'A' ? 'Approved' : participants.user.status === 'D' ? 'Declined' : 'Pending'}
                            </Box>
                        </Text>
                    </Box>
                }
            

          
        </Box>
    )
}